import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { user } from 'services';
import { path } from 'router/sections';
import { TableExt, TableInfo, GridBox } from 'libs/ui';
import { getTableParams } from './grid.params';

export const BenefitGrid = (props) => {
  const { count, count_limit, count_method, getFilter, entries, className, theme, getXlsAction } = props;
  const { t } = useTranslation();
  const history = useHistory();

  /**
   * showinfo
   * @param {*} row
   */
  const showInfo = (row) => {
    if (!row.stay_id || !user.haveRight('stays.view')) {
      return;
    }
    history.push(`${path('stay')}?id=${row.stay_id}`);
  };

  // items
  const items = Object.keys(entries).map((key) => entries[key]);

  // actions
  const actions = [];

  // top actions
  const topActions = [];
  if (count) {
    getXlsAction(topActions);
  }

  const tableParams = useMemo(() => getTableParams(t), []);

  return (
    <GridBox>
      <TableInfo theme={theme} count={count} count_limit={count_limit} count_method={count_method} getFilter={getFilter} actions={topActions} />

      <TableExt
        theme={theme}
        title={t('sections.Льготы')}
        rows={{ count, items }}
        actions={actions}
        className={className}
        refresh={props.refresh}
        onRowClick={showInfo}
        {...tableParams}
      />
    </GridBox>
  );
};
